import React from "react";
import { Check, MessageCircle } from "lucide-react";
import { book, brand } from "../mock";

export default function BookSection() {
  const bookMessage =
    "Hello Nitin Ji, I want a copy of your book. Here's my name and address. Thank You.";

  const onDownload = () => {
    const url = `https://wa.me/${brand.phoneRaw}?text=${encodeURIComponent(bookMessage)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section id="book" className="py-24 lg:py-32 bg-[var(--ink-2)] border-y border-[var(--line)]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* cover */}
          <div className="relative flex justify-center reveal order-2 lg:order-1">
            <div className="absolute w-72 h-72 rounded-full bg-[var(--gold)]/12 blur-3xl" />
            <img
              src={book.cover}
              alt="Export Business Booster Guide"
              className="relative z-10 w-72 sm:w-80 drop-shadow-2xl transition-transform duration-700 hover:-translate-y-2 hover:rotate-1"
            />
          </div>

          {/* content */}
          <div className="reveal order-1 lg:order-2">
            <p className="eyebrow">{book.eyebrow}</p>
            <h2 className="mt-5 font-serif-display text-4xl sm:text-5xl font-semibold leading-tight">
              {book.title}
            </h2>
            <p className="mt-5 text-[var(--muted)] leading-relaxed">{book.desc}</p>

            <ul className="mt-8 space-y-4">
              {book.points.map((p, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-[var(--gold)]/15 flex items-center justify-center shrink-0">
                    <Check size={14} className="text-[var(--gold)]" />
                  </span>
                  <span className="text-[var(--ivory)]/85">{p}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={onDownload}
              className="btn-gold mt-9 px-7 py-3.5 rounded-full inline-flex items-center gap-2"
            >
              <MessageCircle size={17} /> Download Now
            </button>
          </div>
        </div>

        {/* book testimonial */}
        <div className="mt-24 max-w-3xl mx-auto reveal">
          <div className="gold-line mb-12" />
          <blockquote className="text-xl sm:text-2xl font-light leading-[1.7] tracking-[-0.005em] text-[var(--ivory)]/85 text-center">
            “{book.quote.text}”
          </blockquote>
          <div className="mt-12 flex items-center justify-center gap-4">
            <img
              src={book.quote.avatar}
              alt={book.quote.author}
              className="w-14 h-14 rounded-full object-cover border border-[var(--gold)]/40"
            />
            <div>
              <div className="font-serif-display font-semibold tracking-tight">{book.quote.author}</div>
              <div className="text-sm text-[var(--gold)] mt-0.5">{book.quote.title}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
